import React, { useMemo, useState, useEffect, useRef } from 'react';
import {
   Typography, Grid,  Box, 
  
} from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';
import step1 from '../../assets/images/step1.png';
import verification from '../../assets/images/verification.png';
import report from '../../assets/images/report.png';
function Stepper(props) {
      const isMobile = useMediaQuery('(max-width:600px)');
    const StepCircle = ({ src, label, active }) => (
        <Box display="flex" flexDirection="column" alignItems="center">
            <Box
                sx={{
                    backgroundColor:  active ? '#0F31AC' : '#918b96',
                    width: isMobile ? 45 : 55,
                    height: isMobile ? 45 : 55,
                    borderRadius: isMobile ? '30%' : '40%',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    color: '#fff',
                    cursor: 'pointer'
                }}
            >
                <img src={src} alt={label} style={{ width: isMobile ? "15px" : '20px' }} />
            </Box>
            <Typography mt={1} sx={{ fontSize: isMobile ? "8px" : "16px" }}>{label}</Typography>
        </Box>
    );

    const Arrow = () => (
        <Box display="flex" flexDirection="column" alignItems="center">
            <Box
                sx={{
                    width: isMobile ? 50 : 100,
                    height: 1,
                    borderTop: '2px dotted black',
                    position: 'relative',
                    mt: isMobile ? "0px" : "-16px",
                }}
            >
                <Box
                    sx={{
                        width: 10,
                        height: 10,
                        backgroundColor: 'black',
                        transform: 'rotate(45deg)',
                        position: 'absolute',
                        top: '-6px',
                        left: '100%',
                        transformOrigin: 'center',
                    }}
                />
            </Box>
        </Box>
    );
    return ( 
        <>
        <Grid container alignItems="center" justifyContent="center" spacing={3} mb={1}>
                        <Grid item>
                            <StepCircle src={step1} label="Get Started" active={props.value===1}/>
                        </Grid>
        
                        <Grid item sx={{ paddingLeft: isMobile ? "9px !important" : "24px!important" }}>
                            <Arrow />
                        </Grid>
        
                        {/* Step 2 */}
                        <Grid item>
                            <StepCircle src={verification} label="Verify Identity" active={props.value===2} />
                        </Grid>
        
                        <Grid item sx={{ paddingLeft: isMobile ? "9px!important" : "24px!important" }}>
                            <Arrow />
                        </Grid>
        
                        {/* Step 3 */}
                        <Grid item>
                            <StepCircle src={report} label="Get Funding Eligibility Report" active={props.value===3} />
                        </Grid>
                    </Grid>
        </>
    );
}
export default Stepper;